import { call, cancelled, put, takeEvery, takeLatest } from "redux-saga/effects";
import { SECTION } from "./actionTypes";
import {
  duplicateSection,
  getListaSection,
  getSection,
  getSectionHistory,
  getSectionHistoryList,
  getSectionPreview,
  getSectionProducts,
  getSectionSnippets,
  postSectionDownloadList,
  saveSection,
} from "./actions";
import { emptyStringToNull } from "../../helpers/null_empty_string_helper";
import { SECTION_URL } from "../../helpers/url_api_helper";
import moment from "moment";
import { normalizeApiError } from "../../helpers/utils/normalizeApiError";

function* listarSections({ payload }) {
  const controller = new AbortController();
  try {
    emptyStringToNull(payload);
    const res = yield call(SECTION_URL.getSectionLista, payload, {
      signal: controller.signal,
    });
    yield put(getListaSection.success(res));
  } catch (error) {
    yield put(getListaSection.fail(normalizeApiError(error, "Something went wrong retrieving the system's sections, please try again later")));
  } finally {
    if(yield cancelled()) {
      controller.abort();
    }
  }
}

function* obterSection({ payload }) {
  const { sectionId } = payload;

  try {
    const section = yield call(SECTION_URL.getSection, sectionId);
    const res = {
      ...section,
      createDate: moment(section.createDate).format("DD MMM/YY hh:mm A"),
      updateDate: section.updateDate
        ? moment(section.updateDate).format("DD MMM/YY hh:mm A")
        : "",
    };
    yield put(getSection.success(res));
  } catch (error) {
    yield put(
      getSection.fail(
        normalizeApiError(error, "Something went wrong obtaining the section")
      )
    );
  }
}

function* salvarSection({ payload }) {
  const { body, method } = payload;

  try {

    if (method === "POST") {
      yield call(SECTION_URL.postSection, body);
    } else {
      yield call(SECTION_URL.putSection, body);
    }

    yield put(saveSection.success(true));
  } catch (error) {
    yield put(
      saveSection.fail(
        normalizeApiError(
          error,
          "Something went wrong saving the section, please try again later"
        )
      )
    );
  }
}

function* duplicarSection({ payload }) {
    const { sectionId } = payload;
    try {
        const res = yield call(SECTION_URL.postSectionDuplicate, sectionId);
        yield put(duplicateSection.success(res));
    }
    catch (error) {
        yield put(
            duplicateSection.fail(
                normalizeApiError(
                    error,
                    "Something went wrong retrieving the system's section, please try again later"
                )
            )
        );
    }
}

function* listarSectionsHistory({ payload }) {
  try {
    const { sectionId, page } = payload;
    const res = yield call(
      SECTION_URL.getSectionHistoryList,
      sectionId,
      page
    );
    yield put(getSectionHistoryList.success(res));
  } catch (error) {
    yield put(
      getSectionHistoryList.fail(
        normalizeApiError(
          error,
          "Something went wrong retrieving the system's section history"
        )
      )
    );
  }
}

function* obterSectionHistory({ payload }) {
  const { idHistory } = payload;

  try {
    const section = yield call(
      SECTION_URL.getSectionHistory,
      idHistory
    );

    const res = {
      ...section,
      createDate: moment(section.createDate).format("DD MMM/YY hh:mm A"),
      updateDate: section.updateDate
        ? moment(section.updateDate).format("DD MMM/YY hh:mm A")
        : "",
    };

    yield put(getSectionHistory.success(res));
  } catch (error) {
    yield put(
      getSectionHistory.fail(
        normalizeApiError(
          error,
          "Something went wrong retrieving the system's section history"
        )
      )
    );
  }
}

function* obterSectionProducts({ payload }) {
  const { sectionId } = payload;

  try {
    const res = yield call(
      SECTION_URL.getSectionProducts,
      sectionId
    );
    yield put(getSectionProducts.success(res));
  } catch (error) {
    yield put(
      getSectionProducts.fail(
        normalizeApiError(
          error,
          "Something went wrong retrieving the section's products"
        )
      )
    );
  }
};

function* obterSectionSnippets({ payload }) {
  const { sectionId } = payload;

  try {
    const res = yield call(
      SECTION_URL.getSectionSnippets,
      sectionId
    );
    yield put(getSectionSnippets.success(res));
  } catch (error) {
    yield put(
      getSectionSnippets.fail(
        normalizeApiError(
          error,
          "Something went wrong retrieving the section's snippets"
        )
      )
    );
  }
};

function* obterSectionPreview({ payload }) {
  const { sectionId } = payload;
      try {
          const res = yield call(SECTION_URL.getSectionPreview, sectionId);
          yield put(getSectionPreview.success(res));
      } catch (error) {
          yield put(
              getSectionPreview.fail(
                  normalizeApiError(
                      error,
                      "Something went wrong retrieving the system's section preview, please try again later"
                  )
              )
          )
      }
};

function* obterSectionDownloadList({ payload }) {
  const { objFilter } = payload;

  try {
    const res = yield call(SECTION_URL.postSectionDownloadList, objFilter);
    yield put(postSectionDownloadList.success(res));
  } catch (error) {
    yield put(
      postSectionDownloadList.fail(
        normalizeApiError(
          error,
          "Something went wrong retrieving the system's section download list, please try again later"
        )
      )
    );
  }
}

function* SectionSaga() {
  yield takeLatest(SECTION.GET_LIST.REQUEST, listarSections);
  yield takeEvery(SECTION.GET_SECTION.REQUEST, obterSection);
  yield takeEvery(SECTION.SAVE_SECTION.REQUEST, salvarSection);
  yield takeEvery(SECTION.DUPLICATE_SECTION.REQUEST, duplicarSection);

  yield takeEvery(
    SECTION.GET_SECTION_HISTORY_LIST.REQUEST,
    listarSectionsHistory
  );
  yield takeEvery(
    SECTION.GET_SECTION_HISTORY.REQUEST,
    obterSectionHistory
  );

  yield takeEvery(SECTION.GET_SECTION_PRODUCTS.REQUEST, obterSectionProducts);
  yield takeEvery(SECTION.GET_SECTION_SNIPPETS.REQUEST, obterSectionSnippets);

  yield takeEvery(SECTION.GET_SECTION_PREVIEW.REQUEST, obterSectionPreview);

  yield takeEvery(SECTION.POST_SECTION_DOWNLOAD_LIST.REQUEST, obterSectionDownloadList);
}

export default SectionSaga;
